import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { Picture } from '../Picture/Picture';

import css from './styles.module.scss';

import starsBigPatternPng from '/img/patterns/stars.png';
import starsBigPatternWepb from '/img/patterns/stars.webp';
import starsSmallPatternPng from '/img/patterns/stars-small.png';
import starsSmallPatternWebp from '/img/patterns/stars-small.webp';

interface StarsPatternProps extends HTMLAttributes<HTMLPictureElement> {
  withSmallImage?: boolean;
}

const StarsPattern = forwardRef<HTMLDivElement, StarsPatternProps>(
  ({ withSmallImage, ...props }, ref) => {
    return (
      <Picture
        ref={ref}
        {...props}
        className={cn(css.starsPattern, props.className)}
        img={withSmallImage ? starsSmallPatternPng : starsBigPatternPng}
        webp={withSmallImage ? starsSmallPatternWebp : starsBigPatternWepb}
        alt="stars pattern"
      />
    );
  },
);

export { StarsPattern };
